/* eslint-disable */
// import axios from 'axios';
// import storage from 'storejs';
// import  createUuid  from './uuid';
import enCode from './encode';

// 跳入医生站免登录
export default (url, obj) => {
      var obj1 = {
        uid:obj.uid,
        session:obj.session,
        uuid:obj.guid
      }
      const encrypt = enCode.encodeFunc(obj1);
      const appid = encodeURIComponent(encrypt.data);
      const strs = url.split('#');
      let newUrl = `${strs[0]}&isCover=1&uid=${appid}#${strs[1]}`;
      // isQywx
      // 企业微信入口的地方，你就跟以前免登录一样的，以前是有 uid，isCover 这些参数，再加一个isQywx，值传1
        // newUrl = newUrl.replace('http://ysz-web.yxj.org.cn/live/', 'http://ysz-web.yxj.org.cn/yxzbj/'); // 发生产时删除， 暂时测试
      newUrl = `${strs[0]}&isCover=1&uid=${appid}#${strs[1]}`;
      console.log(newUrl)
      window.location.href = newUrl;
};



// WEBPACK FOOTER //
// ./src/utils/jumpYszLive.js